


































































































import { Component, Prop, Vue } from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
import { Table, TableRowsSelect } from "@/utils/decorator";
import TableEnableFlag from "@/components/scope/table-enable-flag.vue";
import { emptyToLine, splitThousands } from "@/utils/common";
import StandardFlag from "@/components/scope/standard-flag.vue";
import dayjs from "dayjs";
const base = namespace("base");
const service = namespace("service");
const app = namespace("app");
const finance = namespace("finance");
@Component({
  components: { TableEnableFlag, StandardFlag }
})
@Table("loadListData")
@TableRowsSelect({
  warningMsg: window._I18N.t("marketing.please-select-card-template"),
  updateStatusFuncName: "confirmUpdateStatus",
  tableRefKey: "table"
})
export default class CustomerEditxxx extends Vue {
  @base.Action getDictionaryList;
  @app.State btnLoading;
  @finance.Action getCustomerUnpaidOrder;
  @finance.State onAccountManageRow;
  dayjs = dayjs;
  emptyToLine = emptyToLine;
  splitThousands = splitThousands;
  searchForm = {};
  orderList: any[] = [];
  row: any = {};
  // 计算金额
  get actuallyAmount() {
    return this.totalOrderAmount;
  }
  get totalOrder() {
    return [].concat(this.mix_selectedRows).length;
  }
  get totalOrderAmount() {
    let totalList = [].concat(this.mix_selectedRows);
    try {
      return totalList
        .reduce((prev, curv) => {
          return (prev || 0) + Number(curv.orderAmount || 0);
        }, 0)
        .toFixed(2);
    } catch (e) {
      return 0;
    }
  }
  get searchList() {
    return [
      {
        label: window._I18N.t("test.keyword"),
        type: "input",
        value: "",
        prop: "searchKey",
        placeholder: window._I18N.t("test.license-name-mobile-vincode")
      }
    ];
  }
  get breadData() {
    return [
      { name: window._I18N.t("finance.payment-management"), path: "/finance/on-account-manage" },
      { name: window._I18N.t("finance.chargeable-details") }
    ];
  }
  form = {
    name: ""
  };
  created() {
    console.log(JSON.parse(sessionStorage.getItem("onAccountId")));
    this.row = this.$route.params.row || JSON.parse(sessionStorage.getItem("onAccountId"));
    this.loadListData();
  }
  toggleSelection(orderList) {
    this.$nextTick(() => {
      const ref = this.$refs as any;
      ref.table.toggleAllSelection();
    });
  }
  handelSelect(value) {}
  loadListData() {
    return this.getCustomerUnpaidOrder({
      customerCode: this.row.customerCode || this.onAccountManageRow.customerCode,
      settlementStatus: 2
    }).then(data => {
      this.orderList = data.data;
      this.toggleSelection(data.data);
      return data;
    });
  }
  returnBack() {
    this.$router.push("/finance/on-account-manage");
  }
  goToCashier() {
    this.$router.push({
      name: "serviceCashier",
      params: {
        id: this.mix_selectedRows[0].orderNo,
        orderList: this.mix_selectedRows as any,
        onAccountTo: "true",
        row: this.$route.params.row
      }
    });
  }
  allSelect(all) {}
  isAllSelect() {}
  handleView(row) {
    let { href } = this.$router.resolve({
      path: `/service/view/${row.orderNo}`
    });
    window.open(href, "_blank");
  }
  // ---------------------------
}
